import {
  instance,
} from './index';

const getPortion = async (portionId) => {
  const res = await instance.get(`/portions/${portionId}`);
  return res;
};

const getPortions = async (productId) => {
  const res = await instance.get(`/portions/all/${productId}`);
  return res;
};

const updatePortion = async (data) => {
  const res = await instance.put(`/portions/${data.id}`, data);
  return res;
};

export {
  getPortions,
  getPortion,
  updatePortion,
};
